Ext.ns('mx.comp.meta');
